@if (appType === ApplicationType.COFUS_DUNAV) {
    <img
        [style.height.px]="70 * scale"
        src="https://www.dunav.com/wp-content/uploads/2021/01/dunav_logo.png"
        alt="Dunav logo"
        class="logo"
        i18n-alt="@@logo.dunav.alt"
    />
}
@if (appType === ApplicationType.COFUS_GLOBOS) {
    <img
        [style.height.px]="60 * scale"
        src="https://globos.rs/images/logo_194x58.svg"
        height="60px"
        alt="Globos logo"
        class="logo"
        i18n-alt="@@logo.globos.alt"
    />
}
